import { toHaveAccessibleDescription } from "@testing-library/jest-dom/dist/matchers";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import './profile.css';
import Avatar from 'react-avatar';
import tokenErrorHandler from "../tokenErrorHandler";
import history from "../../auth/history";
import { Link } from "react-router-dom";
const httpClient = axios.create();

class ProfileDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			fname: '',
			lname: '',
			mobile: '',
			email: '',
			fullAdress: ''
		}
	}


	componentDidMount() {
		this.getProfile();
	}
	componentWillUnmount() {
	}

	getProfile = () => {
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		httpClient.get('/api/v1/retailer/get/'
			+ this.props.agentInfo
			, { headers }
		).then((response) => {
			console.log('get Profile Response' + JSON.stringify(response.data));
			var fullName = '';
			if (response.data.personalInfo != null) {
				var fname = (response.data.personalInfo.fname != "" &&
					response.data.personalInfo.fname != null &&
					response.data.personalInfo.fname != undefined) ?
					response.data.personalInfo.fname : "";
				var lname = (response.data.personalInfo.lname != "" &&
					response.data.personalInfo.lname != null &&
					response.data.personalInfo.lname != undefined) ?
					response.data.personalInfo.lname : "";
				fullName = fname + " " + lname;
			}
			if (response.data.personalInfo != null) {
				var nobile = (response.data.personalInfo.mobile != "" &&
					response.data.personalInfo.mobile != null &&
					response.data.personalInfo.mobile != undefined) ?
					response.data.personalInfo.mobile : "NA";

			}
			if (response.data.personalInfo != null) {
				var email = (response.data.personalInfo.email != "" &&
					response.data.personalInfo.email != null &&
					response.data.personalInfo.email != undefined) ?
					response.data.personalInfo.email : "NA";

			}
			if (response.data.personalInfo != null) {
				var fullAdress = (response.data.personalInfo.address != "" &&
					response.data.personalInfo.address != null &&
					response.data.personalInfo.address != undefined &&
					response.data.personalInfo.address.fullAddress != "" &&
					response.data.personalInfo.address.fullAddress != null &&
					response.data.personalInfo.address.fullAddress != undefined) ?
					response.data.personalInfo.address.fullAddress : "NA";

			}

			this.setState({
				fullName: fullName,
				fname: fname,
				lname: lname,
				mobile: nobile,
				email: email,
				agentId: response.data.id,
				fullAdress: fullAdress
			})

		}).catch(error => {

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}
		});
	}

	backToDashBoard = () => {
		history.push('/dashboard');
		history.go();
	}



	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">
										<div class="dashhead">
											<h3>Profile Details</h3>
											<Link to='/dashboard'>
											<div class="backbtn">
												<button type="button" class="back">Back</button>
											</div>
											</Link>
											
										</div>

										<div class="profile">
											<div class="row">
												<div class="col-12 col-md-4 col-lg-3">
													<div class="proimg">
														<Avatar class="img-fluid" name={this.state.fullName} size={100} round={true} textSizeRatio={2.5} />

														{/* <button type="button" class="editimg" data-bs-toggle="modal" data-bs-target="#imgup">Edit</button> */}
													</div>
												</div>

												<div class="col-12 col-md-8 col-lg-9">
													<div class="proform">
														<div class="row">
															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="fname" placeholder="First name"
																		value={this.state.fname} readonly />
																	<label for="fname">First name</label>
																</div>
															</div>

															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="lname" placeholder="Last name"
																		value={this.state.lname} readonly />
																	<label for="lname">Last name</label>
																</div>
															</div>

															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="mobile" placeholder="mobile" value={this.state.mobile != "" ? "+91-"
																		+ this.state.mobile : "NA"} readonly />
																	<label for="mobile">Mobile number</label>
																</div>
															</div>

															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="email" placeholder="Email" value={this.state.email} readonly />
																	<label for="email">Email ID</label>
																</div>
															</div>

															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="ro" placeholder="RO ID" value={this.state.agentId} readonly />
																	<label for="ro">RO ID</label>
																</div>
															</div>

															<div class="col-12 col-lg-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="role" placeholder="Role" value="Retailer" readonly />
																	<label for="role">Role</label>
																</div>
															</div>

															<div class="col-12">
																<div class="form-floating">
																	<textarea class="form-control" placeholder="Address" rows="4" id="address" readonly disabled value={this.state.fullAdress}></textarea>
																	<label for="address">Address</label>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved.
					<br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, },
		miscReduce: { agentInfo, clientRole, phone, token } }
) => ({
	errorMessage, agentInfo, clientRole, phone, token
});

export default connect(mapStateToProps, null)(ProfileDetails);
